import { updateLocale } from '@americanexpress/one-app-ducks';
import { reportApplicationError } from '@americanexpress/one-identity-ducks';
import { matchLocaleFromRoute } from './matchLocaleFromRoute';
import { MODULE_NAME } from './constants';

export default function multiPageLocale({ dispatch }) {
  return async (nextState, replace, callback) => {
    const { location: { pathname } } = nextState;

    try {
      const locale = matchLocaleFromRoute(pathname);
      const formattedLocale = locale.replace(
        /-([a-z]{2})/i,
        (match, group) => `-${group.toUpperCase()}`
      );

      await dispatch(updateLocale(formattedLocale));
    } catch (error) {
      dispatch(reportApplicationError(
        '500',
        error,
        {
          moduleID: MODULE_NAME,
        }
      ));
      replace(`${pathname.replace(/\/+$/, '')}/error`);
    }
    return callback();
  };
}
